module.exports = __webpack_public_path__ + "static/media/Upload.8a3cae0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/EditProfile/Upload.svg
// module id = 347
// module chunks = 0